import { useEffect, useRef, useState } from 'react';

import { generateShortId } from '@lyearn/core/utils/id';

export default function useFormKey<T>(data: T) {
  const [formKey, setFormKey] = useState<string>(() => generateShortId());
  const stale = useRef(false);

  useEffect(() => {
    if (stale.current && data) {
      stale.current = false;
      setFormKey(generateShortId());
    }
  }, [data]);

  const onRefresh = () => {
    stale.current = true;
  };

  return { formKey, onRefresh };
}
